<template>
	<section class="dashboard-menu">
		<div class="container-fluid">
			<div class="row">
				<!-- Menu Icons Start -->
				<template v-for="menu in userObject.userModules">
					<MenuBox :key="menu.id" v-if="menu.menuLink" :moduleIcon="formatToPath(menu.moduleName)" :moduleName="menu.moduleName" menuLink/>
					<MenuBox :key="menu.id" v-else :moduleIcon="formatToPath(menu.moduleName)" :moduleName="menu.moduleName"  :modulePages="menu.modulePages"/>
				</template>
				<!-- Menu Icons End -->
			</div>
		</div>
	</section>
</template>

<script>
// @ is an alias to /src
import MenuBox from '@/components/menu/MenuBox.vue'
import { mapState } from 'vuex'

export default {
	name: 'home',
	components: {
		MenuBox
	},
	data() {
		return {
			
		}
	},
	computed: {
		...mapState({
      userObject: "userObject"
		})
	},
	mounted() {

	},
	methods: {
		
	}
}
</script>
